module.exports = {
    returnNullForEmpty: (value) => {
        if(value === '')
            return null;
        else 
            return value;    
    }
}